import type { TDatadogErrorLog } from 'utils/datadog/types'

export const DEFAULT_TAKE = 30

export const FETCH_DOCUMENTS_ERROR_LOG: TDatadogErrorLog = {
  from: 'src/modules/documents/common/contexts/documents-management/provider.tsx',
  name: 'Fetch Documents Error',
  message: 'Failed to fetch documents list',
}

export const UPLOAD_DOCUMENT_ERROR_LOG: TDatadogErrorLog = {
  from: 'src/modules/documents/common/contexts/documents-management/provider.tsx',
  name: 'Upload Document Error',
  message: 'Failed to get presigned URL for document upload',
}

export const DELETE_DOCUMENT_ERROR_LOG: TDatadogErrorLog = {
  from: 'src/modules/documents/common/contexts/documents-management/provider.tsx',
  name: 'Delete Document Error',
  message: 'Error occurred while deleting document',
}

export const FETCH_DOCUMENTS_GENERAL_ERROR_LOG: TDatadogErrorLog = {
  from: 'src/modules/documents/common/contexts/documents-management/provider.tsx',
  name: 'Fetch Documents General Error',
  message: 'Error occurred while fetching documents',
}

export const UPLOAD_DOCUMENTS_GENERAL_ERROR_LOG: TDatadogErrorLog = {
  from: 'src/modules/documents/common/contexts/documents-management/provider.tsx',
  name: 'Upload Documents General Error',
  message: 'Error occurred while uploading documents',
}

export const REFRESH_STORAGE_INFO_ERROR_LOG: TDatadogErrorLog = {
  from: 'src/modules/documents/common/contexts/documents-management/provider.tsx',
  name: 'Refresh Storage Info Error',
  message: 'Error occurred while refreshing storage info',
}
